module.exports = __webpack_public_path__ + "static/media/p3_face.aefb314b.png";